// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_errorBoundaryContainer__dQAbr {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background);
  padding: 20px;
}

.styles_errorBoundaryContent__YQFOR {
  max-width: 400px;
  width: 100%;
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.styles_errorBoundaryContent__YQFOR h2 {
  font: var(--typography-h2);
  color: var(--color-black);
  margin-bottom: 16px;
}

.styles_errorMessage__GBsQ0 {
  font: var(--typography-body-m-regular);
  color: var(--color-error);
  margin-bottom: 32px;
  padding: 16px;
  background-color: rgba(206, 32, 33, 0.1);
  border-radius: 8px;
}

.styles_errorActions__qvkf0 {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.styles_errorButton__A27v4 {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font: var(--typography-body-m-medium);
  cursor: pointer;
  transition: all 0.2s;
  background-color: var(--color-accent-blue);
  color: white;
}
.styles_errorButton__A27v4:hover {
  background-color: var(--color-accent-blue-dark);
}
.styles_errorButton__A27v4.styles_secondary__4bF3L {
  background-color: transparent;
  color: var(--color-accent-blue);
  border: 1px solid var(--color-accent-blue);
}
.styles_errorButton__A27v4.styles_secondary__4bF3L:hover {
  background-color: var(--color-accent-blue);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/auth-error-boundary/styles.module.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,sCAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,oBAAA;EACA,0CAAA;EACA,YAAA;AAAF;AAEE;EACE,+CAAA;AAAJ;AAGE;EACE,6BAAA;EACA,+BAAA;EACA,0CAAA;AADJ;AAGI;EACE,0CAAA;EACA,YAAA;AADN","sourcesContent":["@import \"mixins\";\n.errorBoundaryContainer {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-background);\n  padding: 20px;\n}\n\n.errorBoundaryContent {\n  max-width: 400px;\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  padding: 40px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.errorBoundaryContent h2 {\n  font: var(--typography-h2);\n  color: var(--color-black);\n  margin-bottom: 16px;\n}\n\n.errorMessage {\n  font: var(--typography-body-m-regular);\n  color: var(--color-error);\n  margin-bottom: 32px;\n  padding: 16px;\n  background-color: rgba(206, 32, 33, 0.1);\n  border-radius: 8px;\n}\n\n.errorActions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n}\n\n.errorButton {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font: var(--typography-body-m-medium);\n  cursor: pointer;\n  transition: all 0.2s;\n  background-color: var(--color-accent-blue);\n  color: white;\n\n  &:hover {\n    background-color: var(--color-accent-blue-dark);\n  }\n\n  &.secondary {\n    background-color: transparent;\n    color: var(--color-accent-blue);\n    border: 1px solid var(--color-accent-blue);\n\n    &:hover {\n      background-color: var(--color-accent-blue);\n      color: white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBoundaryContainer": `styles_errorBoundaryContainer__dQAbr`,
	"errorBoundaryContent": `styles_errorBoundaryContent__YQFOR`,
	"errorMessage": `styles_errorMessage__GBsQ0`,
	"errorActions": `styles_errorActions__qvkf0`,
	"errorButton": `styles_errorButton__A27v4`,
	"secondary": `styles_secondary__4bF3L`
};
export default ___CSS_LOADER_EXPORT___;
